import { getEarliest, defaultTime } from '@/api/orderScheduledAt'
import { reactive, toRefs, onMounted, watch, computed, ref, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { setSession, getSession, upCase, getDistance, isNum } from '@/util'
import {
  getTyresApplyCoupons,
  tyrePackageRightList,
  tyrePackageRightListNotCanUse,
  getTyrePackageDiscount,
  getDefaultCommoditie,
  getSixCouponMsg,
  postTyreOrder,
  getTyres,
  getInventory,
  getSystemConfig
} from '@/api/tyre'
import { getCustomerInfo } from '@/api/mine'
import ServiceType from '@/components/tyre/ServiceType.vue'
import DiscountUseDetail from '@/components/shoppingCart/DiscountUseDetail'
import Calendar from '@/components/common/Calendar'
import ServiceDeal from '@/components/common/serviceDeal'
import { couponList } from '@/util/plan'
import { Toast } from 'vant'
import _ from 'lodash'
import moment from 'moment'
import { getDealers } from '@/api/plan'
import SubmitOrder from '@/components/order/SubmitOrder.vue'
import PopUp from '@/components/common/PopUp'
import { contractData } from '@/assets/js/tyreContract'
import { formValidate, showTip, getPostData } from '@/util/order/tyreOrder'
import '@/assets/css/common.scss'

export default {
  components: {
    ServiceType,
    DiscountUseDetail,
    Calendar,
    ServiceDeal,
    SubmitOrder,
    PopUp
  },
  setup() {
    const store = useStore()
    let router = useRouter()
    let route = useRoute()
    let from = route.query.from
    let { plate } = route.query
    let typeFlag = from == 'carPage' ? 1 : 2
    let { formattedAddress } = store.state
    const state = reactive({
      tyreCouponCheckArr: [false, false, false],
      form: {},
      CouponNum: false,
      tyreLoad: false,
      tyreTypeNum: 0,
      numbers: 0,
      showVisible: false,
      tyreCouponCheck: false,
      checkIds: [],
      selectIds: [],
      tyrecouponList: [],
      activeCoupon: true,
      contractData,
      saId: '',
      tyre: [],
      active: 0,
      gs_code: '',
      isSubmitRule: false,
      submitAble: true,
      from: from,
      typeFlag: typeFlag,
      model: true,
      tyreImgList: [],
      rightContent: {},
      formattedAddress,
      dealerInfo: null,
      showPopUp: 0,
      showCalendar: 0,
      showDeal: 0,
      tyrecouponSelected: [],
      preferential: [],
      couponInfo: [],
      sixCouponList: [1],
      tyreCount: 0,
      sixAmount: 0,
      sixAmountList: [],
      sixCouponCheck: false,
      tyreSubPrice: null,
      mallCouponCheck: false,
      couponNumList: { c0: '' },
      couponDetailList: [],
      allMsrp: 0,
      earliest: null,
      appointTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'), //,
      couponTypeFlag: 0, //优惠券类型
      fromQr: 0,
      customerInfo: {}, //客户信息
      showLoading: false,
      amditLoading: false, //提交订单loading
      dealerInven: null,
      commodities: null, //经销商库存信息
      betterLine: false, //推荐在线预约
      couponValidate: true, //6位码优惠券是否可以提交
      tyreInfo: [],
      sweepCode: false, //是否通过扫码进入
      buyTyre: [], //最终可以下单的轮胎
      autoGetCouponFlag: false, //展示自动领券
      shoppingCoupon: [],
      notUseCoupon: false,
      mbpn: '', //配件号
      arriveDistance: 2,
      onLineFlag: false,
      disableOnLineStr: '',
      hasLoadConfig: false,
      showOnLineOverlay: false,
      hasLoadStock: false
    })
    const showSubmitOrderPopUp = ref()
    const discountUseDetailRef = ref()
    let productPrice = computed(() => {
      //商品金额合计
      let data = 0
      state.tyreInfo?.map(item => {
        let canButSate = state.active === 1 ? 'shopBuyFlag' : 'lineBuyFlag'
        if (item[canButSate]) {
          let temp = isNum(item.ind_price) ? item.ind_price : item.msrp
          let price = temp * item.count
          data += price
        }
      })
      return data.toFixed(2)
    })
    let allMsrp = computed(() => {
      //商品金额合计
      let data = 0
      state.tyreInfo?.map(item => {
        let canButSate = state.active === 1 ? 'shopBuyFlag' : 'lineBuyFlag'
        if (item[canButSate]) {
          let price = item.msrp * item.count
          data += price
        }
      })
      return data.toFixed(2)
    })
    const sumitOrderTxt = computed(() => {
      return state.hasLoadStock ? `去结算( ${tyreTotal.value} )` : '正在加载'
    })
    const subtractPrice = computed(() => {
      //优惠金额
      let data = 0
      let flag = false
      if (state.sixCouponCheck) {
        data = state.sixAmount
      } else if (state.mallCouponCheck) {
        state.preferential.map(item => {
          let price = item.coupon?.rightContent?.subtractPrice
          if (price === 0.1) {
            flag = true
            price = price * 100
          }
          data += price
        })
      }
      // else if (state.couponTypeFlag == 3 && state.tyreSubPrice != null) {
      //   data = state.tyreSubPrice
      // }
      // console.log(data)
      data = flag ? data / 100 : data
      return parseFloat(data.toFixed(2))
    })
    const actualPrice = computed(() => {
      //实付金额
      let count = state.couponTypeFlag == 3 && Object.keys(state.form).length ? 0 : (productPrice.value - subtractPrice.value).toFixed(2)
      return count < 0 ? 0 : count
    })
    const shouldShop = computed(() => {
      if (state.formattedAddress === '定位失败') {
        state.betterLine = false
      }
      let flagC = false
      if (state.tyreInfo) {
        let flag = false
        state.tyreInfo?.map(item => {
          if (item.buyFlag) {
            flag = true
          }
          if (item.couponArr) flagC = true
        })
        if (!flag) {
          state.betterLine = false
          state.onLineFlag && (state.active = 2)
          return flag
        }
      }
      if (state.formattedAddress !== '定位失败' && state.dealerInfo?.distance < state.arriveDistance) {
        if (!flagC) {
          state.active = 1
        }
        return true
      }
      state.onLineFlag && (state.active = 2)
      return false
    })
    const relocation = () => {
      state.showLoading = true
      store.dispatch('getLocation')
      setTimeout(() => {
        state.showLoading = false
      }, 5000)
    }
    const changeActive = num => {
      state.active = Number(num)
      state.shoppingCoupon = []
      state.form = {}
      nextTick(() => {
        getCoupons()
        // getTyreCoupons()
        if (state.active === 0) {
          Toast({ type: 'fail', message: state.disableOnLineStr })
        }
      })
    }
    const getDealersFn = async () => {
      let { position } = store.state
      let { lat, lng } = position && position
      let dearParams = {
        gsCode: state.gs_code,
        latitude: lat,
        longitude: lng
      }
      let { list } = await getDealers(dearParams)
      let info = list[0]
      info.distance = getDistance(info.distance)
      if (info.distance > state.arriveDistance) {
        state.onLineFlag && (state.active = 2)
      }
      state.dealerInfo = info
      state.gs_code = info.gs_code
    }
    const getInventoryFn = async () => {
      //获取经销商营业时间库存
      const inventory = await getInventory({
        tyreIds: state.ids,
        gsCode: state.gs_code
      })
      state.dealerInven = inventory.dealer
      state.commodities = inventory.commodities
      setTyreCommod(state.tyre, state.commodities)
      setDefaultTime()
    }
    const setTyreCommod = (tyreInfo, commodInfo) => {
      //设置轮胎库存信息
      tyreInfo.map((item, index) => {
        item.ind_price = commodInfo[index].ind_price
        item.msrp = commodInfo[index].msrp || item.msrp
        let shopCount = commodInfo[index].dealer_stock + commodInfo[index].two_hours_stock
        let lineCount = commodInfo[index].dealer_stock + commodInfo[index].stock
        item.shopCount = shopCount ? shopCount : 0
        item.lineCount = lineCount ? lineCount : 0
        if (item.count > shopCount) {
          item.shopBuyFlag = false
          item.buyFlag = false
          if (item.count <= lineCount) {
            //可在线预约的轮胎
            if (state.onLineFlag) {
              state.betterLine = true
              state.active = 2
            }
          }
        } else {
          item.shopBuyFlag = true
          item.buyFlag = true //可到店订购的轮胎
        }
        if (item.count > lineCount) {
          item.lineBuyFlag = false
        } else {
          item.lineBuyFlag = true
        }
      })
      state.tyreInfo = tyreInfo
      state.hasLoadStock = true
      nextTick(() => {
        getCoupons()
        getTyreCoupons()
      })
    }
    //准备提交订单的轮胎数量
    let tyreTotal = computed(() => {
      let data = state.active === 1 ? state.tyreInfo.filter(item => item.buyFlag) : state.tyreInfo.filter(item => item.lineBuyFlag)
      return data.reduce((total, item) => {
        return total + item.count
      }, 0)
    })
    const addImg = () => {
      store.commit('SETCURRENTORDERINFO', {
        customerInfo: state.customerInfo,
        tyre: state.tyre,
        active: state.active,
        dealerInfo: state.dealerInfo,
        preferential: state.preferential,
        notUseCoupon: state.notUseCoupon,
        appointTime: state.appointTime
      })
      let mbpn = state.tyre[0].mbpn
      if (!mbpn) {
        return
      }
      router.push({
        path: '/addTyreImg',
        query: { mbpn, event: '添加轮胎图片' }
      })
    }

    const setPreferential = data => {
      if (state.fromAddImage) {
        state.fromAddImage = false
      } else {
        state.preferential = data || []
      }
    }
    const setCouponParams = () => {
      tyreValidate()
      let minProdPrice = null
      minProdPrice = Math.min.apply(
        Math,
        state.buyTyre.map(item => {
          return item.ind_price === 0 ? 0 : item.ind_price || item.msrp
        })
      )
      let productId = ''
      let numbers = ''
      let data = []
      // 到店
      if (state.active === 1) {
        data = state.tyreInfo.filter(item => item.buyFlag)
        //有不支持到店的轮胎，重置
        if (data.length < state.tyreInfo.length) {
          state.shoppingCoupon = []
        }
      } else {
        // 预约
        data = state.tyreInfo.filter(item => item.lineBuyFlag)
      }

      data.map(item => {
        if (productId) {
          productId += `,${item.id}`
          numbers += `,${item.count}`
        } else {
          productId = item.id
          numbers += item.count
        }
      })
      state.numbers = numbers
      return {
        minProdPrice,
        productId: productId,
        numbers: numbers,
        gsCodes: state.gs_code,
        gsCode: state.gs_code
      }
    }
    const couponTypeCheck = (mallFlag, sixFlag, tyreFlag, couponTypeFlag) => {
      state.mallCouponCheck = mallFlag //true
      state.sixCouponCheck = sixFlag //false
      state.tyreCouponCheck = tyreFlag
      state.couponTypeFlag = couponTypeFlag
    }
    const getCoupons = async () => {
      let params = setCouponParams()
      let data = await getTyresApplyCoupons(params)
      if (!state.sweepCode) {
        if (data.list?.length > 0) {
          couponTypeCheck(true, false, false, 1)
        } else {
          couponTypeCheck(false, true, false, 2)
        }
      }
      state.couponInfo = couponList(
        data.list?.map(item => {
          return { ...item.coupon, ...item }
        })
      )
    }
    const getTyreCoupons = async e => {
      e && e.stopPropagation()
      state.tyreLoad = true
      // if (state.tyreTypeNum > 1) {
      // /tyres/tyrePackageRightListNotCanUse
      let list = getSession('currentBuyProductInfo') || []
      let params = list.map((item, index) => ({
        gsCode: item.gsCode,
        tyreNo: item.mbpn,
        selectId: state.form[index] || [],
        buyCount: item.count,
        itemPrice: item.msrp
      }))
      let data = await tyrePackageRightListNotCanUse(params)
      // state.tyrecouponList = data.list
      let li = state.tyreInfo.map(item => {
        data.list.map(i => {
          if (i.tyreNo == item.mbpn) {
            item.couponArr = i
          }
        })
        return item
      })
      state.tyreInfo = li
      state.tyreLoad = false
      //   return
      // }
      // let datas = state.tyreInfo[0]
      // let price = state.tyreInfo[0]?.ind_price ? state.tyreInfo[0]?.ind_price : state.tyreInfo[0].msrp || 0
      // let params = { itemPrice: price, gsCode: state.gs_code, tyreNo: datas.mbpn, buyCount: datas.count, selectIds: state.selectIds || [] }
      // let data = await tyrePackageRightList(params)
      // state.tyrecouponList = data.list
      // state.tyreLoad = false
      // if (state.selectIds.length > 0) {
      //   // TyrePackageDiscount(state.selectIds)
      // }
    }
    const getTyrecouponSelected = () => {
      state.tyrecouponSelected = []
      let arr = []
      for (let i in state.form) {
        if (state.form[i]) {
          state.form[i].map(item => {
            state.tyreInfo[i].couponArr.tyreRightVoList.map(itm => {
              if (item == itm.id) {
                itm.tyreNo = state.tyreInfo[i].mbpn
                arr.push(itm)
              }
            })
          })
        }
      }
      state.tyrecouponSelected = arr
    }
    const getTyreInfo = () => {
      let tyre = getSession('currentBuyProductInfo') || []
      state.tyreTypeNum = tyre.length
      if (tyre[0]) {
        state.tyreImgList = getSession(tyre[0].mbpn) || []
        state.mbpn = tyre[0].mbpn
      }
      //商品数量
      let data = 0
      let ids = []
      tyre?.map(item => {
        data += item.count
        ids.push(item.id)
      })
      state.tyreCount = data
      state.ids = ids.join(',')
      state.tyre = tyre
    }
    const getDefaultCommoditieFn = async () => {
      let { lat, lng } = store.state.position
      let params = {
        tyreId: state.tyre.id,
        gsCode: state.gs_code,
        latitude: lat,
        longitude: lng
      }
      let data = await getDefaultCommoditie(params)
      let dealer = data[0].dealer
      dealer.distance = getDistance(dealer.distance)
      store.commit('SETDEARINFO', dealer)
      state.updataDealer += 1
    }
    const addSixCoupon = () => {
      let len = state.sixCouponList.length
      state.sixCouponList.push(len + 1)
      let key = `c${len}`
      state.couponNumList = { ...state.couponNumList, [key]: '' }
    }
    const delCouponByIndex = num => {
      state.couponDetailList.splice(num, 1, {})
      state.sixAmountList.splice(num, 1, 0)
      state.sixAmountList = [...state.sixAmountList]
    }
    const signCouponMsg = (text, flag) => {
      Toast(text)
      state.couponValidate = flag
      state.couponValidateText = text
    }
    const getSixCoupon = async num => {
      state.couponValidate = true
      state.couponValidateText = ''
      let couponCode = null
      let boUserId = getSession('sixCoupons')?.saId
      couponCode = state.couponNumList[`c${num}`]
      if (!couponCode || couponCode.length !== 6) {
        delCouponByIndex(num)
        return
      }
      try {
        var data = await getSixCouponMsg({
          code: couponCode,
          gsCode: state.gs_code,
          boUserId
        })
        let isSameCoupon = false
        state.couponDetailList.map((item, index) => {
          if (JSON.stringify(item) !== '{}' && index !== num) {
            if (data.tyreQuantity !== item.tyreQuantity || data.amount !== item.amount) {
              return (isSameCoupon = true)
            }
          }
        })
        if (isSameCoupon) {
          signCouponMsg('不同核销条数-面值的优惠券不能同时使用', false)
          delCouponByIndex(num)
          return
        }
        if (state.tyreCount < data.tyreQuantity) {
          signCouponMsg(`您只购买了${state.tyreCount}条轮胎，仅可使用${parseInt(state.tyreCount / data.tyreQuantity)}张该优惠券`, false)
          return
        }
        let amount = data.amount ? data.amount : 0
        state.sixAmountList.splice(num, 1, amount)
        state.sixAmountList = [...state.sixAmountList]
        state.couponDetailList.splice(num, 1, data)
      } catch (err) {
        delCouponByIndex(num)
        Toast(err)
      }
    }
    const checkSixCoupon = e => {
      if (e) {
        couponTypeCheck(false, true, false, 2)
        state.form = {}
        state.tyreCouponCheckArr = []
      }
    }
    const checkMallCoupon = e => {
      if (e) {
        couponTypeCheck(true, false, false, 1) //(mallFlag, sixFlag, tyreFlag, couponTypeFlag)
        state.form = {}
        state.tyreCouponCheckArr = []
        state.couponInfo = [...state.couponInfo]
      } else {
        discountUseDetailRef.value.setSelected(false)
        setPreferential([])
      }
    }
    const checkTyreCoupon = (e, index) => {
      if (!e) {
        state.form[index] = []
      } else {
        couponTypeCheck(false, false, true, 3)
      }
      // if (e) {
      //   couponTypeCheck(false, false, true, 3)
      // } else {
      //   state.form = {}
      //   state.checkIds = []
      // }
    }
    const setAppointTime = data => {
      state.appointTime = data
    }

    const tyreValidate = () => {
      let buyTyre = []
      let flag = false
      let buyState = state.active === 1 ? 'shopBuyFlag' : 'lineBuyFlag'
      state.tyreInfo.map(item => {
        if (item[buyState]) {
          flag = true
          buyTyre.push(item)
        }
      })
      state.buyTyre = buyTyre
      if (!flag) {
        Toast('库存不足')
      }
      return flag
    }
    const isTyreLessCoupon = data => {
      //判断轮胎价格是否小于等于优惠券面值
      console.log(439, data)
      let tyreList = data.tyre.data
      let tyreMin = Math.min.apply(
        Math,
        tyreList.map(item => {
          return item.productPrice || item.msrp
        })
      )
      let couponVlaue = data.coupon[0] ? data.coupon[0]['couponValue'] : undefined
      if (tyreMin < couponVlaue) {
        return true
      }
      return false
    }
    const isSumitOrder = () => {
      if (state.tyrecouponList.length && state.tyreCouponCheck) {
        state.showVisible = true
      } else {
        sumitOrder()
      }
    }
    const sumitOrder = _.debounce(async () => {
      state.showVisible = false
      if (state.couponTypeFlag == 3) {
        getTyrecouponSelected()
        if (!Object.keys(state.form).length) {
          state.couponTypeFlag = 0
        }
      }
      try {
        if (!state.couponValidate) {
          Toast(state.couponValidateText)
          return
        }
        let flag = formValidate(state.customerInfo)
        let tyreFlag = tyreValidate()
        if (!flag || !tyreFlag) return
        let postD = getPostData(state)
        let lessFlag = isTyreLessCoupon(postD)
        if (lessFlag) {
          Toast('经销商轮胎定价低于优惠金额未满足优惠券使用门槛，烦请调整后重新下单，详情请咨询经销商')
          return
        }
        if (!state.submitAble) {
          return
        }
        state.amditLoading = true
        state.submitAble = false
        let data = await postTyreOrder({ data: postD })
        if (state.autoGetCouponFlag && state.mallCouponCheck) {
          Toast('已为您自动领取轮胎优惠券')
        }
        state.submitAble = true
        state.amditLoading = false
        // 清空轮胎图片
        state.mbpn && store.commit('SETTYREPICTURES', { key: state.mbpn, value: [] })
        store.dispatch('getCountOfShoppingCar')
        if (state.active === 2) {
          // 预约
          if (data.payAmount === 0 || data.orderStatusFlag == 11) {
            router.replace({ path: '/orderDetail', query: { orderId: data.id, miniMallOrder: 0, event: '查看订单详情' } })
          } else {
            showSubmitOrderPopUp.value.chosePayType(data)
          }
        } else {
          // 到店
          if (state.fromQr === 1) {
            // 来自扫码
            router.replace({ path: '/orderDetail', query: { orderId: data.id, miniMallOrder: 0, event: '查看订单详情' } })
          } else {
            router.replace({
              path: '/OrderOver',
              query: { orderNum: data.orderNo, fromQr: state.fromQr, orderId: data.id, event: '查看到店订单二维码' }
            })
          }
        }
      } catch (err) {
        state.submitAble = true
        state.showLoading = false
        state.amditLoading = false
        Toast(err)
      }
    }, 300)

    const setDefaultTime = () => {
      let earliest = getEarliest(state.dealerInven)
      state.earliest = moment(earliest).format('YYYY-MM-DD HH:mm')
      if (!state.fromAddImage) {
        state.appointTime = defaultTime(earliest)
      }
    }
    const getDefaultSixCoupon = async () => {
      //如果扫码进入，获取默认6位券码
      let sixCoupons = getSession('sixCoupons')
      state.saId = sixCoupons.saId
      state.fromQr = state.saId ? 1 : 0
      if (sixCoupons.gsCode === state.gs_code && sixCoupons.coupon) {
        state.sweepCode = true
        state.sixCouponCheck = true
        state.couponTypeFlag = 2
        let couponList = sixCoupons.coupon?.split(',')
        let minest = Math.min(state.tyreCount, sixCoupons.quantity)
        for (let i = 0; i < minest; i++) {
          state.couponNumList[`c${i}`] = couponList[i]
          await getSixCoupon(i, 'index')
          if (i > 0) {
            state.sixCouponList.push(state.sixCouponList.length + 1)
          }
        }
      }
    }
    // 显示优惠详情
    const showDiscountUseDetail = () => {
      state.showPopUp += 1
      const data = state.preferential?.map(item => item._flag) || []
      discountUseDetailRef.value.setSelected(data)
    }
    // 轮胎包优惠券价格计算
    const TyrePackageDiscount = async ids => {
      let price = state.tyreInfo[0]?.ind_price ? state.tyreInfo[0]?.ind_price : state.tyreInfo[0].msrp || 0
      let params = {
        itemPrice: price,
        buyCount: state.numbers,
        selectIds: ids.length ? ids.join(',') : ''
      }
      let data = await getTyrePackageDiscount(params)
      state.tyreSubPrice = data.discount
    }
    // watch(
    //   () => state.tyreCouponCheck,
    //   n => {
    //     if (n) {
    //       if (state.tyreTypeNum > 1 && !state.form.length) {
    //         Toast('您所购买的轮胎有型号不适用轮胎包计划优惠券。')
    //       }
    //     }
    //   }
    // )
    watch(
      () => state.form,
      n => {
        let count = false
        for (let i in state.form) {
          if (i && state.form[i].length > 0) {
            count = true
            state.tyreCouponCheckArr[i] = true
          } else {
            state.tyreCouponCheckArr[i] = false
            getTyreCoupons()
          }
        }
        state.CouponNum = count
        if (count) {
          couponTypeCheck(false, false, true, 3)
        } else {
          // couponTypeCheck(false, true, false, 2)
          getTyreCoupons()
        }
      },
      { deep: true }
    )
    watch(
      () => store.state.position,
      () => {
        getDefaultCommoditieFn()
      }
    )
    watch(
      () => store.state.formattedAddress,
      n => {
        state.showLoading = false
        state.formattedAddress = n
        getDealersFn()
      }
    )
    watch(
      () => state.sixAmountList,
      data => {
        let num = 0
        data.map(item => {
          num += item
        })
        state.sixAmount = num
      }
    )
    const getDistanceConfig = async () => {
      try {
        let { mini_mall_disable_online_order_reason: onLineObj = {}, mini_mall_onsite_distance_limit: distanceLimitObj = {} } = await getSystemConfig()
        let disableOnLineStr = (onLineObj && onLineObj.value && onLineObj.value.trim()) || ''
        state.arriveDistance = (distanceLimitObj && distanceLimitObj.value) || 2
        state.disableOnLineStr = disableOnLineStr
        state.onLineFlag = !disableOnLineStr
        if (disableOnLineStr) {
          state.showOnLineOverlay = true
          setTimeout(() => {
            state.showOnLineOverlay = false
          }, 3000)
        }
        // console.log('Config---res--->', state.arriveDistance, state.onLineFlag)
      } catch (e) {
        state.arriveDistance = 2
        state.onLineFlag = false
      } finally {
        state.hasLoadConfig = true
      }
    }
    const goBack = () => {
      // router.go(-1)
      state.showOnLineOverlay = false
    }
    onMounted(async () => {
      state.gs_code = route.query.gs_code //|| "GS0019995";
      let shoppingCoupon = route.query?.shoppingCoupon || ''
      let notUseCoupon = route.query?.notUseCoupon || false
      state.shoppingCoupon = notUseCoupon ? false : shoppingCoupon.split(',').filter(item => item)
      state.notUseCoupon = notUseCoupon
      try {
        //获取到店距离、在线订购开关
        await getDistanceConfig()
      } catch (error) {
        console.error('获取到店距离失败')
      }
      await getTyreInfo() //获取轮胎信息
      getDefaultSixCoupon() //扫码进入获取默认6位码优惠券
      if (state.from === 'exclusive') {
        let vehicle = getSession('exclusiveVehicle')
        let { name, mobile, plate, dealer } = vehicle
        let { vehicleId, tyreId } = route.query
        let params = {
          vehicleId,
          tyreId
        }
        state.customerInfo = {
          username: name,
          phone: mobile,
          licensePlate: plate,
          dealer,
          imgArr: []
        }
        let data = await getTyres(params)
        data.tyre.count = 1
        state.tyre = [data.tyre]
      } else {
        if (getSession('fromAddImage')) {
          state.fromAddImage = true
          setSession('fromAddImage', false)
          let notUseCoupon = getSession('currentOrderInfo').notUseCoupon
          state.preferential = getSession('currentOrderInfo').preferential //
          state.notUseCoupon = notUseCoupon
          state.shoppingCoupon = notUseCoupon ? false : state.preferential.map(item => item._flag)
          state.appointTime = getSession('currentOrderInfo').appointTime
          state.active = getSession('currentOrderInfo').active
          state.customerInfo = getSession('currentOrderInfo').customerInfo
        } else {
          let customerInfo = await getCustomerInfo({ customerId: 1 })
          state.customerInfo = { ...customerInfo, ...state.customerInfo }
        }
        if (plate) {
          state.customerInfo.licensePlate = plate
        }
        await getDealersFn()
      }
      getInventoryFn() //获取库存
    })

    return {
      ...toRefs(state),
      isSumitOrder,
      TyrePackageDiscount,
      getTyreCoupons,
      getTyrecouponSelected,
      checkTyreCoupon,
      productPrice,
      allMsrp,
      addImg,
      showTip,
      relocation,
      setPreferential,
      subtractPrice,
      actualPrice,
      addSixCoupon,
      getSixCoupon,
      setAppointTime,
      checkSixCoupon,
      checkMallCoupon,
      sumitOrder,
      changeActive,
      upCase,
      showSubmitOrderPopUp,
      shouldShop,
      tyreTotal,
      discountUseDetailRef,
      showDiscountUseDetail,
      isTyreLessCoupon,
      goBack,
      sumitOrderTxt
    }
  }
}
